import validator from "validator";
import numeral from "numeral";
export { default as pluralize } from "pluralize";
export { numeral };
/**
 * Grabs the initials from a string.
 *
 * @param {String} string
 */

export function getInitials(string) {
  if (string === void 0) {
    string = "";
  }

  var initials = string.toUpperCase().split(" ").map(function (name) {
    return name.charAt(0);
  });
  return initials.length === 1 ? initials[0] : "" + initials[0] + initials[initials.length - 1];
}
/**
 * Finds phone numbers in a string and wraps
 * them in the appropriate html tag.
 *
 * @param {String} string
 */

export function registerPhoneNumbers(string) {
  if (string === void 0) {
    string = "";
  }

  if (!string) return string;
  return string.replace(/(\d\d\d-\d\d\d-\d\d\d\d)/g, '<a href="tel:$1">$1</a>');
}
/**
 * Finds email addresses in a string and wraps
 * them in the appropriate html tag.
 *
 * @param {String} string
 */

export function registerEmails(string) {
  if (string === void 0) {
    string = "";
  }

  if (!string) return string;
  return string.replace(/([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)/gi, '<a href="mailto:$1">$1</a>');
}
/**
 * Determines validitity of an email
 *
 * @param {String} email
 */

export function emailIsValid(email) {
  return /\S+@\S+\.\S+/.test(email);
}
/**
 * Formats a string or number into currency.
 *
 * @param {String|Number} amount
 * @deprecated Use `formatCurrency` instead.
 */

export function currency(amount) {
  return formatCurrency(amount);
}
/**
 * Abbreviates a number representing a price
 * eg: 100000 -> 100K  |  2500000 -> 2.5M
 *
 * @param {Number|String} value
 * @deprecated Use `formatCurrency` instead.
 */

export function currencyShort(value) {
  return formatCurrencyShort(value);
}
/**
 * Gives you the first name given a name string
 *
 * @param {String} name
 */

export function getFirstName(name) {
  if (name === void 0) {
    name = "";
  }

  return name.split(" ")[0];
}
/**
 * Validates a mobile phone number.
 *
 * @param {String|Number} phone
 */

export function isMobilePhone(phone) {
  return validator.isMobilePhone(phone);
}
/**
 * Provides a formatted number
 *
 * @param {Number} amount
 * @param {String} format
 */

export function formatNumber(amount, format) {
  if (format === void 0) {
    format = "0,0";
  }

  return numeral(amount).format(format);
}
/**
 * Provides a formatted currency.
 *
 * @param {Number} amount
 * @param {String} format
 */

export function formatCurrency(amount, format) {
  if (format === void 0) {
    format = "$0[,]0";
  }

  return formatNumber(amount, format);
}
/**
 * Abbreviates a number representing a price
 * eg: 100000 -> 100K  |  2500000 -> 2.5M
 *
 * @param {Number|String} value
 */

export function formatCurrencyShort(value) {
  var formattedValue = numeral(value).format("0.0a");
  var leftDigits = formattedValue.split(".")[0];

  if (leftDigits.length === 1) {
    formattedValue = numeral(value).format("$0.[00]a");
  } else if (leftDigits.length === 2) {
    formattedValue = numeral(value).format("$0.[0]a");
  } else if (leftDigits.length >= 3) {
    formattedValue = numeral(value).format("$0a");
  }

  return formattedValue.toUpperCase();
}
/**
 * Finds the youtube id for the given url if there is one present.
 *
 * https://youtu.be/dQw4w9WgXcQ
 * https://www.youtube.com/embed/dQw4w9WgXcQ
 * https://www.youtube.com/watch?v=dQw4w9WgXcQ
 *
 * @param {string} url
 */

export function getYoutubeId(url) {
  var regex = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=|\?v=)([^#&?]*).*/;

  var _a = (url || "").match(regex) || [],
      youtubeId = _a[2];

  return youtubeId;
}
/**
 * Finds the youtube id for the given url if there is one present.
 *
 * https://vimeo.com/407879852
 * https://vimeo.com/user9072077/review/392145388/ad8d96d1e8
 *
 * @param {string} url
 */

export function getVimeoId(url) {
  var regex = /^.*(vimeo.+\/(\d+)|vimeo.+\/review\/(\d+)).*/;

  var _a = (url || "").match(regex) || [],
      vimeoId = _a[2];

  return vimeoId;
}
/**
 * Finds the youtube id for the given url if there is one present.
 *
 * https://my.matterport.com/show/?m=NeiMEZa9d93&play=1
 *
 * @param {string} url
 */

export function getMatterportId(url) {
  var regex = /^.*(matterport\/|show\?m=|&m=|\?m=)([^#&?]*).*/;

  var _a = (url || "").match(regex) || [],
      matterportId = _a[2];

  return matterportId;
}